import { render, staticRenderFns } from "./ImportRailSummary.vue?vue&type=template&id=0096b5ea"
import script from "./ImportRailSummary.vue?vue&type=script&lang=js"
export * from "./ImportRailSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports